export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7096.348e7f0a.jpg";